import { logout } from '@/entities/auth'
import SignOut from '@/shared/assets/images/SignOut.svg'
import { useAppDispatch } from '@/shared/lib/redux'

export const Logout = () => {
    const dispatch = useAppDispatch()

    const handleLogout = () => {
        dispatch(logout())
    }
    return (
        <li onClick={handleLogout} className="py-2 flex transition px-3 text-color-dark bg-white hover:cursor-pointer hover:bg-black/5">
            <SignOut width={24} height={24} />
            <div className="ml-[6px] text-nowrap text-base">
                Выйти из учетной записи
            </div>
        </li>
    )
}